import { fetchRequest, postRequest } from 'services/api.service';
import authService from 'services/auth.service';
import { CallToken, CommunicationProvider, ScheduleCallPayload } from 'typings';
import { Buffer } from 'buffer';

const callApiRequestConfig = {
  baseURL: `${process.env.REACT_APP_CORE_API_URL}/api/concierge/calls/`,
  transformRequest: [
    function transformCreateMessageRequest(data: any, headers: any) {
      headers.Authorization = `Bearer ${authService.getAuthToken()}`;

      return JSON.stringify(data);
    },
  ],
};

async function fetchCallToken(
  communicationProvider: CommunicationProvider,
  communicationProviderAccountId: string | null
): Promise<CallToken> {
  const { token } = await fetchRequest(
    `/token/${communicationProvider}?communicationProviderAccountId=${communicationProviderAccountId}`,
    callApiRequestConfig
  );

  // parse the jwt token to get the expiration date
  const [, payload] = token.split('.');
  const decodedPayload = JSON.parse(Buffer.from(payload, 'base64').toString());
  const expiresAt = decodedPayload.exp;

  return { communicationProvider, communicationProviderAccountId, token, expiresAt };
}

async function answerInboundCall(leadId: string) {
  await postRequest(`/inbound/answer`, { leadId }, callApiRequestConfig);
}

async function initiateLiveTransfer(leadId: string) {
  await postRequest(`/outbound`, { leadId }, callApiRequestConfig);
}

async function cancelLiveTransfer(leadId: string) {
  await postRequest(`/outbound/cancel`, { leadId }, callApiRequestConfig);
}

async function mergeCall(leadId: string) {
  await postRequest(`/outbound/merge`, { leadId }, callApiRequestConfig);
}

async function initiateCallCenterFlow(leadId: string) {
  await postRequest(`/outbound`, { leadId }, callApiRequestConfig);
}

async function scheduleCall(leadId: string, payload: ScheduleCallPayload) {
  await postRequest(
    '/schedule',
    {
      ...payload,
      leadId,
    },
    callApiRequestConfig
  );
}

export default {
  fetchCallToken,
  answerInboundCall,
  initiateLiveTransfer,
  cancelLiveTransfer,
  mergeCall,
  initiateCallCenterFlow,
  scheduleCall,
};
